import { render, staticRenderFns } from "./AddPaymentHPS.vue?vue&type=template&id=0840984e"
import script from "./AddPaymentHPS.vue?vue&type=script&lang=js"
export * from "./AddPaymentHPS.vue?vue&type=script&lang=js"
import style0 from "./AddPaymentHPS.vue?vue&type=style&index=0&id=0840984e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports